module.exports = __webpack_public_path__ + "img/knowledge.f39a9771.png";